import { __rest } from "tslib";
import React from 'react';
import { makeStyles, Popover as MUIPopover } from '@material-ui/core';
import clsx from 'clsx';
import { reactStyling } from '@getgo/chameleon-core';
const useStyles = makeStyles((theme) => {
    const { popover } = reactStyling(theme.tokens);
    return {
        // @ts-ignore
        popover: ({ noMinWidth }) => (Object.assign(Object.assign({}, popover), { padding: 0, paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2), minWidth: noMinWidth ? 'unset' : 180, borderColor: 'var(--goto-popover-border-color)', boxShadow: 'var(--goto-popover-elevation)' })),
    };
});
export const Popover = (_a) => {
    var { children, onPopover, open, triggerRef, noMinWidth, anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'left',
    }, className, transformOrigin = {
        vertical: 'top',
        horizontal: 'left',
    }, transparent } = _a, otherProps = __rest(_a, ["children", "onPopover", "open", "triggerRef", "noMinWidth", "anchorOrigin", "className", "transformOrigin", "transparent"]);
    const handleClose = (event) => {
        onPopover(false, event);
    };
    const classes = useStyles({ noMinWidth });
    return (React.createElement(MUIPopover, Object.assign({ elevation: 3, open: open, anchorEl: triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current, onClose: handleClose, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, PaperProps: {
            style: {
                listStyle: 'none',
            },
        } }, otherProps),
        React.createElement("div", { className: clsx(transparent ? {} : classes.popover, className) }, children)));
};
